






















































import popupPay from '../_comps/popupPay.vue'
import openApp from '@ivy/fts/openApp'
import Lyric from './lyric.vue'
import ControlBox from './controlBox.vue'
import AudioPromise from '@ivy/fts/audioPromise'
import { isWeixin } from '@ivy/fts/utils'
import { Component, Vue, Prop } from 'vue-property-decorator'
import store from '../../store'

@Component({
  components: { ControlBox, popupPay, Lyric }
})

export default class IvyPlayerIndex extends Vue {
  hideAudio: any = [9513, 9518, 9522, 9515, 9519, 9512, 9511, 9520, 9521, 9517, 9516, 9514, 9510, 9507, 9509, 9506, 9508, 9527, 9523, 9524, 9528, 9526, 9537, 9536, 9534, 9532, 9530, 9531, 9533, 9529, 9525, 9567, 9566, 9568, 9563, 9565, 9564, 9560, 9561, 9562, 9556, 9559, 9558, 9554, 9557, 9555, 9583, 9581, 9582, 9580, 9577, 9579, 9576, 9578, 9574, 9570, 9571, 9572, 9569, 9573, 9575, 9545, 9546, 9544, 9547, 9542, 9543, 9541, 9539, 9540, 9538, 9548, 9549, 9550, 9551, 9552, 9553, 9535]
  reloadLyric: any = 1
  curValue: any = 1
  audioObj: any = null
  isLyric: boolean = false
  albums: any = [] // 专辑信息
  audio: any = {} // 音频信息
  index: any = 0 // 如果是列表的话当前是第几首
  currentTime: any = 0 // 当前播放时间
  qr: boolean = false
  isListLoop: boolean = true
  showPanel: boolean = false
  album: any = {}
  isWeixin: boolean = isWeixin()
  userInfo: any = {}
  isShow: boolean = true
  async mounted() {
    this.userInfo = (await this.$store.login(this)) ||  {}
    let { audioId, from } = this.$route.query
    if (!this.isWeixin || this.$route.query.from === 'qr' && this.hideAudio.includes(+audioId)) {
      this.isShow = false
    }
    this.qr = !!(this.$route.query.from === 'qr')
    // if (!this.isWeixin) {
      // 建议将本链接复制到微信并使用微信浏览器打开本链接~目前非微信浏览器播放音频时会出现进度条和歌词不滚动的情况，程序🐒正在努力修复中~
      // this.$Toast('建议在微信中使用')
    // }
    // 初始化页面
    await this.initPage()
    // 设置分享时显示的图片和标题
    await this.$store.setupShare({ imgUrl: this.audio.pic_url + '?x-oss-process=image/resize,w_750', title: this.audio.title })
  }
  async initPage() {
    const { from, tag_id, albumId: id, index, audioId, bigAlbumId } = this.$route.query
    if (bigAlbumId) {
      console.log('request bigalbum detail')
      const { data } = await this.$axios.get(`/api/audios/resource/bigAlbum/getDetail`, {
        params: {
          token: store.logined.token,
          id: bigAlbumId,
        }
      })
      let audios = []
      let isGroup = data.show_type === 'group'
      if (isGroup) {
        for (let group of data.groups) {
          audios.push(...(group.list || []))
        }
      } else {
        audios = data.audios
      }

      this.album = { ...data, audios }
      this.albums = audios
    } else if (id !== "undefined" && id) {
      let { data } = await this.$axios.get(`/api/mobile/audios/resource2/albumDetail`, {
        params: { id, includes: 'audios,comment_count' }
      })
      this.album = data
      this.albums = data.audios
      if (this.qr) {
        this.albums = this.albums.filter(c => ['律动', '故事', '歌曲', '童谣'].includes(c.audio_track))
      }
    } else if (from === 'playAllEveryday') {
      let { data } = await this.$axios.get(`/api/mobile/audios/resource2/getDailySentenceList`, {
        params: { offset: 0, limit: 20, order: 'DESC' }
      })
      this.albums = data.list
    }
    this.index = index && +index || 0
    await this.loadAudio(audioId || this.albums[this.index].id)
  }
  async loadAudio(id, play = false) {
    const { from } = this.$route.query
    let { data } = await this.$axios.get('/api/mobile/audios/resource2/audioDetail', {
      params: {        id, includes: 'lyric', from: ['timeline', 'groupmessage', 'singlemessage'].includes(`${from}`) ? 'share' : `${from}`, sign: this.$route.query.sign, albumId: this.$route.query.albumId
      }
    })
    this.audio = data
    this.audio.url = this.audio.audio_address
    this.audio.duration = +this.audio.audio_length
    this.reloadLyric = 0
    if (this.audioObj) {
      await this.audioObj.pause()
    }
    this.audioObj = await new AudioPromise(data.audio_address, e => this.updateTime(e))
    await this.$nextTick()
    this.reloadLyric = 1
    if (play) {
      let controlBox = this.$refs.controlBox as any
      await controlBox.play(0)
    }
  }
  async playCurrent(index) {
    this.index = index
    await this.loadAudio(this.albums[this.index].id, true)
  }
  async changeAudio(delta) {
    if (!this.albums || !this.albums.length) return
    let temp_index = (this.index + delta + this.albums.length) % this.albums.length
    if (!this.qr && !this.albums[temp_index].listen && this.albums[temp_index].has_access === 0 && this.albums[temp_index].access_type === 'sale') {
      this.$Toast('该音频为付费音频')
      return
    } else if (!this.qr && !this.albums[temp_index].listen && this.albums[temp_index].has_access === 0 && (this.albums[temp_index].access_type === 'vip' || this.albums[temp_index].access_type === 'sale_vip')) {
      this.$Toast('该音频需开通会员')
      return
    } else {
      this.index = temp_index
      await this.loadAudio(this.albums[temp_index].id, true)
    }
  }
  reSetLoop() {
    this.isListLoop = !this.isListLoop
    this.$Toast(this.isListLoop ? '当前为列表循环模式' : '当前为单曲循环模式')
  }
  wechatPayOver(res) {
    this.$emit('on-wechat-pay', res)
    if (res.d) {
      this.$Toast('专辑购买成功')
      this.audio = {}
      this.album = {}
      this.initPage()
    }
  }
  updateTime(e) {
    if (this.audio.duration - Math.round(e.target.currentTime) <= 1) {
      let controlBox = this.$refs.controlBox as any
      this.isListLoop ? this.changeAudio(1) : controlBox.play(0)
    }
    this.currentTime = e.target.currentTime
    this.curValue = Math.floor((this.currentTime / this.audio.duration) * 100)
  }
}
